<template>
  <div class="maintenance-wrapper">
    <!-- 中间核心区域 -->
    <div class="main-content">
      <!-- 图片（请替换为你的实际图片路径） -->
      <div class="image-wrapper">
        <img 
          :src="require('@/assets/system-maintenance.png')" 
          alt="系统维护升级中" 
        />
      </div>

      <!-- 主标题 -->
      <h2 class="title">{{ $t('maintenance.maintenance_title') }}</h2>

      <!-- 描述文本 -->
      <p class="desc">
        {{ $t('maintenance.maintenance_desc') }}
      </p>

      <!-- 操作按钮：重新加载（点击刷新页面，检测服务是否恢复） -->
      <button class="retry-btn" @click="handleRetry">
        {{ $t('maintenance.reload_btn') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage',
  methods: {
    handleRetry() {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
/* 外层容器：占满全屏，使用 flex 居中 */
.maintenance-wrapper {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
}

/* 内容容器，限制最大宽度，保持居中 */
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 360px;
  width: 100%;
  margin-top: 85px;
}

.image-wrapper {
  width: 180px;
  height: 180px;
  margin-bottom: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持比例，不拉伸 */
}

.title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
  letter-spacing: 1px;
}

.desc {
  font-size: 15px;
  color: #888888;
  line-height: 1.6;
  margin: 0 0 32px 0;
}

.retry-btn {
  background: #3b7cff;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 12px 48px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  box-shadow: 0 4px 12px rgba(59, 124, 255, 0.3);
  letter-spacing: 0.5px;
}

.retry-btn:active {
  background: #2a5fc7;
  transform: scale(0.96);
}
</style>
